import {
  Observer
} from "./chunk-XX3CIG5U.js";

// node_modules/@ckeditor/ckeditor5-image/src/image/imageloadobserver.js
var ImageLoadObserver = class extends Observer {
  /**
   * @inheritDoc
   */
  observe(domRoot) {
    this.listenTo(domRoot, "load", (event, domEvent) => {
      const domElement = domEvent.target;
      if (this.checkShouldIgnoreEventFromTarget(domElement)) {
        return;
      }
      if (domElement.tagName == "IMG") {
        this._fireEvents(domEvent);
      }
    }, { useCapture: true });
  }
  /**
   * @inheritDoc
   */
  stopObserving(domRoot) {
    this.stopListening(domRoot);
  }
  /**
   * Fires {@link module:engine/view/document~Document#event:layoutChanged} and
   * {@link module:engine/view/document~Document#event:imageLoaded}
   * if observer {@link #isEnabled is enabled}.
   *
   * @param domEvent The DOM event.
   */
  _fireEvents(domEvent) {
    if (this.isEnabled) {
      this.document.fire("layoutChanged");
      this.document.fire("imageLoaded", domEvent);
    }
  }
};

export {
  ImageLoadObserver
};
/*! Bundled license information:

@ckeditor/ckeditor5-image/src/image/imageloadobserver.js:
  (**
   * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
   *)
*/
//# sourceMappingURL=chunk-5UJG77VP.js.map
